/**
 * Kotilinga vs Temple category scope for API query params.
 * Mirrors backend KOTILINGA_CATEGORY_SLUGS (loaded via /api/config).
 */
import settings from '../config/settings';

const DEFAULT_SCOPE_SLUG = 'kadambavanam';

/** @returns {string[]} Root category slugs (e.g. ['kadambavanam']) */
export function getKotilingaCategorySlugsArray() {
  const backend = settings.getBackendConfig();
  const fromApi = backend?.kotilinga?.categorySlugs;
  if (Array.isArray(fromApi) && fromApi.length > 0) {
    return fromApi.map((s) => String(s).trim().toLowerCase()).filter(Boolean);
  }
  const env = process.env.REACT_APP_KOTILINGA_CATEGORY_SLUGS;
  if (env) {
    return String(env)
      .split(',')
      .map((s) => s.trim().toLowerCase())
      .filter(Boolean);
  }
  return [DEFAULT_SCOPE_SLUG];
}

/** Comma-separated slugs for parent_category_slugs / exclude_parent_category_slugs */
export function getKotilingaCategorySlugsCsv() {
  const slugs = getKotilingaCategorySlugsArray();
  return slugs.length ? slugs.join(',') : DEFAULT_SCOPE_SLUG;
}

/** Query params: include Kotilinga/Kadambavanam subtree */
export function kotilingaIncludeCategoryParams() {
  return { parent_category_slugs: getKotilingaCategorySlugsCsv() };
}

/** Query params: Temple = exclude Kotilinga scope subtree */
export function templeExcludeCategoryParams() {
  return { exclude_parent_category_slugs: getKotilingaCategorySlugsCsv() };
}
